import QRCode from "qrcode";
import logoC from "../assets/logoC.jpeg";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts;

/// TO print Dispatch Slip
export default class PrintDispatchService {
  genQR(text) {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(text, function (err, url) {
        if (err) reject(err);
        resolve(url);
      });
    });
  }

  imageToBase64(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  async Printpdf(dispatchData) {
    try {
      const companyAdd = dispatchData.dispatchedByAddress;
      const logoUrl = logoC;

      // Convert logo to base64
      const compLogo = await new Promise((resolve, reject) => {
        this.imageToBase64(logoUrl, function (base64String) {
          resolve(base64String);
        });
      });

      var docDefinition = {
        pageMargins: [20, 30, 20, 30],
        pageSize: "A4",
        footer: function (currentPage, pageCount) {
          return {
            stack: [
              {
                text: currentPage.toString() + " of " + pageCount,
                alignment: "center"
              }
            ]
          };
        },
        content: [
          {
            text: "Dispatch Advice",
            alignment: "center",
            fontSize: 18,
            bold: true,
            margin: 5
          },
          {
            table: {
              widths: ["35%", "45%", "20%"],
              body: [
                [
                  {
                    margin: [10, 10, 0, 0],
                    width: 170,
                    height: 60,
                    image: compLogo
                  },
                  {
                    text: [
                      {
                        text: "Optimum Nutrition\n",
                        bold: true,
                        margin: [0, 70, 0, 0],
                        fontSize: 12,
                        alignment: "center"
                      },
                      {
                        text: companyAdd + "\n",
                        fontSize: 10,
                        alignment: "center"
                      },
                      {
                        text:
                          "Dispatch Id" +
                          " - " +
                          dispatchData.dispatchId +
                          "\n",
                        fontSize: 10,
                        alignment: "center"
                        // + 'Dispatched By' + ' - ' + dispatchData.dispatchedBy + '\n',
                      },
                      {
                        text:
                          "Dispatched Date" +
                          " - " +
                          dispatchData.dispatchedDate +
                          "\n",
                        fontSize: 10,
                        alignment: "center"
                      },
                      {
                        text: "Tel: 011 - 49594959",
                        fontSize: 10,
                        italics: true,
                        alignment: "center"
                      }
                    ]
                  },
                  {
                    margin: [20, 10, 5, 5],
                    qr: dispatchData.dispatchId,
                    fit: "80"
                  }
                ],
                [
                  {
                    colSpan: 3,
                    text: [
                      {
                        bold: true,
                        text:
                          "Customer Details: " +
                          dispatchData.dispatchedTo +
                          "\nAddress: " +
                          dispatchData.billingAddress
                      }
                    ]
                  },
                  "",
                  ""
                ]
              ]
            },
            layout: ""
          },
          {
            margin: -1,
            table: {
              widths: ["36%", "46%", "19.5%", "25%"],
              body: this.getDispatchedData(dispatchData)
            }
          },
          {
            //for special instruction
            table: {
              heights: [10, 90],
              margin: 5,
              widths: ["*"],
              body: [["Other Comments or Special Instructions"], [""]]
            }
          }
        ],
        styles: {
          filledHeader: {
            bold: true,
            fontSize: 14,
            color: "white",
            fillColor: "black",
            alignment: "center"
          }
        }
      };

      pdfMake
        .createPdf(docDefinition)
        .download(dispatchData.dispatchId + ".pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  }

  //to get Dispatched data
  getDispatchedData(data) {
    let d = [];

    d.push(["Carton No", "Product Specification", "Total Quantity"]);

    data.cartonList.forEach((childObj) => {
      if (childObj.cartonId.length > 0)
        d.push([childObj.cartonId, childObj.name, childObj.totalQty]);
      // else if (childObj.CartonId.length > 0)
      //     d.push([childObj.CartonId, childObj.TotalQty]);
    });

    d.push([
      { alignment: "right", colSpan: 3, text: "Total Quantity : " + data.qty },
      {}
    ]);
    return d;
  }
}
